module.exports = __webpack_public_path__ + "media/application/images/icons/topics-consumer-pebble-dark-green-rgb-a5aeabe7bfdaaccdcd488ce0e5402b54.svg";